import { render, staticRenderFns } from "./ChatTypeSelector.vue?vue&type=template&id=3633d15a&scoped=true"
import script from "./ChatTypeSelector.vue?vue&type=script&lang=js"
export * from "./ChatTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatTypeSelector.vue?vue&type=style&index=0&id=3633d15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633d15a",
  null
  
)

export default component.exports